import { offersFiltersKey } from './keys'

const flippedTableFiltersKey = () => {
  const flip = obj => {
    const ret = {}
    Object.keys(obj).forEach(key => {
      ret[obj[key]] = key
    })
    return ret
  }
  return flip(offersFiltersKey())
}

export const convertApiFiltersToAppFilters = apiFilters => {
  const filterKeys = flippedTableFiltersKey()
  const convert = filter => {
    const appFilterName = filterKeys[filter?.key]
    const converters = {
      producerCountry: filter => ({ countryFilter: filter?.byName }),
      grapesFilter: filter => {
        return {
          [appFilterName]: {
            list: filter?.childrenInputs?.find(
              input => input?.key === 'grapeAndMonocepage.grape'
            )?.byName,
            switcher: filter?.childrenInputs?.find(
              input => input?.key === 'grapeAndMonocepage.monocepage'
            )?.value,
          },
        }
      },
      deliveryTermsFilter: filter => ({ [appFilterName]: filter?.byName?.[0] }),
      countryOfShipmentFilter: filter => ({
        [appFilterName]: filter?.byName?.[0],
      }),
      minimalBatchFilter: filter => ({
        [appFilterName]: filter?.minValue,
      }),
      priceFilter: filter => {
        const price = filter?.childrenInputs?.find(
          filter => filter?.key === 'pricePerBottle.value'
        )
        const currency = filter?.childrenInputs?.find(
          filter => filter?.key === 'pricePerBottle.currency'
        )
        return {
          [appFilterName]: {
            currency: currency?.byName?.[0],
            interval: {
              minValue: price?.minValue || 0,
              maxValue: price?.maxValue,
            },
          },
        }
      },
      bestOfferPriceFilter: filter => {
        const price = filter?.childrenInputs?.find(
          filter => filter?.key === 'bestOfferPricePerBottle.value'
        )
        const currency = filter?.childrenInputs?.find(
          filter => filter?.key === 'bestOfferPricePerBottle.currency'
        )
        return {
          ['bestOfferFilter']: {
            currency: currency?.byName?.[0],
            interval: {
              minValue: price?.minValue || 0,
              maxValue: price?.maxValue,
            },
          },
        }
      },
      alcoholLevelFilter: filter => ({
        [appFilterName]: {
          minValue: filter?.minValue || 0,
          maxValue: filter?.maxValue,
        },
      }),
      wwlRatingFilter: filter => ({
        [appFilterName]: filter?.byName?.[0],
      }),
      FacetDateRangeFilter: filter => ({
        [appFilterName]: { fromDate: filter?.fromDate, toDate: filter?.toDate },
      }),
      FacetListFilterSelection: filter => {
        return { [appFilterName]: filter?.byName }
      },
      FacetBooleanFilterSelection: filter => {
        return { [appFilterName]: filter?.value }
      },
    }
    // if (!appFilterName) return
    const converter =
      converters[appFilterName] || converters[filter?.__typename]
    if (!converter) return
    return converter(filter)
  }

  return (apiFilters || {}).reduce((acc, filter) => {
    const convertedFilter = convert(filter)
    if (!convertedFilter) return acc
    return {
      ...acc,
      ...convertedFilter,
    }
  }, {})
}
